import React, { PropTypes } from 'react';
import classnames from 'classnames';

import { connect } from 'react-redux';
import { setInView } from '../actions/section';

import Nav from './Nav.jsx';
import { Gallery, GalleryItem } from './Gallery';
import SectionIntro from './SectionIntro.jsx';
import SectionHistory from './SectionHistory.jsx';
import SectionQuote from './SectionQuote.jsx';
import SectionMap from './SectionMap.jsx';
import SectionNewProducts from './SectionNewProducts.jsx';
import SectionAllProducts from './SectionAllProducts.jsx';
import SectionPlaces from './SectionPlaces.jsx';
import SectionCerts from './SectionCerts.jsx';
import SectionFooter from './SectionFooter.jsx';

function mapStateToProps(state) {
  const { sections, places } = state;
  return {
    sections,
    places: places.items,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onSetInViewSection: (section) => {
      if (section) {
        dispatch(setInView(section));
      }
    },
  };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class App extends React.Component {
  static propTypes = {
    sections: PropTypes.array,
    onSetInViewSection: PropTypes.func,
    lang: PropTypes.string,
    places: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.state = {
      lastScrollTop: 0,
      isScrollingDown: false,
      isScrollEnd: false,
      isZoomoutOpen: false,
      currentPlacesSlide: 0,
    };


    // Bind methods
    this.onSlideClick = this.onSlideClick.bind(this);
    this.closeZoomout = this.closeZoomout.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
    this.scrollHandler();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  }


  onSlideClick(index) {
    if (window.innerWidth < 768) {
      return;
    }

    // add scrolllock class on body
    document.childNodes[1].classList.add('scroll-lock');
    this.setState({
      currentPlacesSlide: index,
      isZoomoutOpen: true,
    });
  }

  closeZoomout() {
    // remove scrolllock class on body
    document.childNodes[1].classList.remove('scroll-lock');
    this.setState({
      isZoomoutOpen: false,
    });
  }

  scrollHandler = () => {
    const { lastScrollTop } = this.state;

    const documentScroll = (document.body.scrollTop > 0) ?
      document.body.scrollTop : document.documentElement.scrollTop;

    const scrollTop = documentScroll + window.innerHeight / 2;
    const { sections, onSetInViewSection } = this.props;
    let sectionInView = null;
    const sectionKeys = Object.keys(sections);

    /* enhanced version search section in view */
    for (let i = sectionKeys.length - 1; i > -1; i--) {
      const currentSection = sections[sectionKeys[i]];

      if (currentSection.offset <= scrollTop) {
        sectionInView = sectionKeys[i];
        break;
      }
    }

    // detect scroll direction
    const isScrollingDown = (documentScroll > lastScrollTop);
    // detect if scroll is ended
    const isScrollEnd = (
      window.innerHeight + documentScroll >= document.body.scrollHeight
    );

    this.setState({
      lastScrollTop: documentScroll,
      isScrollingDown,
      isScrollEnd,
    });

    // only if that section was never in view
    if (!sections[sectionInView].wasInView) {
      onSetInViewSection({ id: sectionInView });
    }
  }

  render() {
    const { isScrollingDown, isScrollEnd, currentPlacesSlide, isZoomoutOpen } = this.state;
    const { places } = this.props;
    const isNavHidden = isScrollingDown && !isScrollEnd;

    const styles = {
      wrapper: classnames('app'),
      zoomout: classnames({
        zoomout: true,
        'zoomout--active': isZoomoutOpen,
      }),
      zoomoutClose: classnames('zoomout--close'),
      zoomoutOverlay: classnames('zoomout--overlay'),
    };

    return (
      <div className={styles.wrapper}>

        <SectionIntro />

        <SectionHistory />
        <SectionQuote />
        <SectionMap />
        <SectionNewProducts />
        <SectionAllProducts />
        <SectionPlaces onSlideClick={this.onSlideClick} />
        <SectionCerts />

        <SectionFooter />

        <Nav hidden={isNavHidden} />

        {/* Zoomout gallery */}
        <div className={styles.zoomout}>
          <Gallery
            slidesToShow={1}
            color="white"
            slideIndex={currentPlacesSlide}
            hideDotCursor
          >
            {places.map((i, index) => <GalleryItem key={`gallery-zoomout-item-${index}`} {...i} />)}
          </Gallery>
          <div className={styles.zoomoutClose} onClick={this.closeZoomout}>
            <span />
            <span />
          </div>
          <div className={styles.zoomoutOverlay} onClick={this.closeZoomout}></div>
        </div>

      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/App.jsx
 **/